import React from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import GroupIcon from '@material-ui/icons/Group';

const useStyles = makeStyles({
  NotificationContainer: {
    padding: '10px 3.5px 20.5px 13px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
  },
  date: {
    color: '#a4a8ac',
    textAlign: 'right',
    fontSize: '12px',
    fontWeight: 'normal',
    LineWeight: 1.67,
    letterSpacing: '0.22px',
    marginBottom: '3px',
  },
  icon: {
    background: '#fedb75',
    height: '24px',
    width: '24px',
    padding: '4px',
    borderRadius: '100%',
    marginRight: '15.5px',
  },
  detailsContainer: {
    display: 'flex',
  },
  notificationText: {
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: 1.43,
    letterSpacing: '0.25px',
    color: '#49515a',
  },
  link: {
    color: '#4b8c6f',

    '&:visited': {
      color: '#4b8c6f',
    },
  },
});

export const LeadsNotification = ({ notification = {} }) => {
  const classes = useStyles();
  const { time, jsonMessage } = notification;
  const url = `${window.location.origin}/pool-recommendation/${jsonMessage.jobId}`;

  return (
    <Grid item xs={12} classes={{ root: classes.NotificationContainer }}>
      <Typography classes={{ root: classes.date }}>{time}</Typography>
      <div className={classes.detailsContainer}>
        <GroupIcon classes={{ root: classes.icon }} />
        <div className={classes.notificationText}>
          You have <b>{jsonMessage.count} new Leads</b> for{' '}
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className={classes.link}
          >
            {jsonMessage.jobRole}
          </a>{' '}
          job post
        </div>
      </div>
    </Grid>
  );
};
